import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import BaseSelect from '@/components/ui/Select/BaseSelect';

import usePatch from '@/hooks/usePatch';

import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({
	name: yup.string().required('Name is a required field'),
});

export default function Category(props) {
	const { open, onClose, data, categories } = props;

	const isEdit = !!data;
	const isGroup = isEdit && data.group_id;

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			name: data?.categoryname || '',
			group: data?.group_id || '',
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const { mutate: codeAction } = usePatch({
		url: !isEdit ? `categorycomponent` : `categorycomponent/${data?.id}`,
		method: isEdit ? 'patch' : 'post',
		callback: async (res) => {
			if ([200, 201].includes(res.status) && res.data) {
				toast.success(res.data?.message || `Group ${res.status === 200 ? 'updated' : 'created'} successfully`);
			}
			props.onSave();
			handleClose();
		},
		onError: () => {
			handleClose();
		},
	});

	const onSubmit = (data) => {
		const { group } = data;
		const obj = { categoryname: data.name, categorytype: 'P-GRUPPE', status: 1, categorynumber: '', };
		if (props.data?.id) obj.id = props.data.id;
		if (!isGroup && group) obj.group = group;
		if (isGroup && group) obj.group = [{ id: props.data.group_category_relation_id, groupid: group }];
		if (isGroup && !group) obj.group = [];
		codeAction(obj);
		handleClose();
	};
	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-category-group' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[380px]'>
				<span className='text-2xl modal-title'>{isEdit ? `Edit (${data.categoryname})` : 'Legg til ny under-kategori'}</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					<BaseInputValidation control={control} name='name' label='Navn' errors={errors} required />
					<BaseSelect
						control={control}
						name='group'
						label='Kategori'
						errors
						data={categories}
						config={{
							styles: {},
							classes: 'col-span-3',
							disabled: false,
							optionLabel: '--category type--',
							keyVal: 'id',
							keyName: 'groupname',
							keyLabel: 'groupname',
						}}
						size='small'
					/>
					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							{isEdit ? 'Oppdater' : 'Legg til'}
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
